export const initialContext = {
    isLoggedIn: false,
    currentUser: null,
    adminUser: false,
    citepayAdminUser: false,
    authToken: null,
    users: null,
    editedUser: null,
    agencies: null,
    defaultAgency: null,
    balances: null,
    initialized: null,
    courtsByAgency: null,
    fullCourtData: null,
    showPasswordDialog: false,
    requestUrl: (window.API_URL + window.PATH)
};